import { beSetupAxiosInstance } from '../../axios/beSetupAxios';

const getJomPayPayment = async (requestData: any) => {
  const params = {
    filters: requestData?.params?.filters,
    search: requestData?.params?.search,
    sortField: requestData?.params?.sortField,
    sortOrder: requestData?.params?.sortOrder,
    currentPage: requestData?.params?.pagination.current,
    pageSize: requestData?.params?.pagination.pageSize,
  };

  const url = `/redCash/api/v1.0/jompay/list`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const jomPayPaymentService = {
  getJomPayPayment,
};

export default jomPayPaymentService;
